import * as React from "react";
import { Helmet } from "react-helmet";

const AppTitle: React.FC = (): JSX.Element => {
  return (
    <Helmet>
      <title>{"Platform | Fluid Attacks"}</title>
    </Helmet>
  );
};

export { AppTitle };
